import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Shared() {
    const { token } = useParams();
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get(`${API}/shared/${token}`)
            .then(r => setData(r.data))
            .catch(() => setError("this conversation is no longer shared"));
    }, [token]);

    return (
        <div className="relative z-10 min-h-screen px-6 md:px-12 py-10 max-w-3xl mx-auto">
            <Link to="/" className="inline-block font-heading text-2xl tracking-tight text-ink" data-testid="shared-brand">pax</Link>

            {error && (
                <div className="mt-12 bg-white border border-clayHover rounded-3xl p-10 text-center" data-testid="shared-error">
                    <AlertTriangle className="w-6 h-6 text-inkSoft mx-auto mb-3" />
                    <p className="font-journal italic text-ink">{error}</p>
                </div>
            )}

            {data && (
                <div className="mt-10" data-testid="shared-thread">
                    <div className="bg-clay/50 border border-clayHover rounded-2xl px-5 py-3 mb-8 flex items-center gap-3">
                        <Sparkles className="w-4 h-4 text-terracotta flex-shrink-0" />
                        <p className="text-sm text-inkSoft font-body leading-relaxed">
                            this is a shared conversation between <span className="text-ink">{data.owner_name || "someone"}</span> and <span className="text-ink">pax</span>, an AI companion. it is not a clinical assessment.
                        </p>
                    </div>
                    <h1 className="font-heading text-3xl tracking-tight text-ink mb-2" data-testid="shared-title">{data.title}</h1>
                    <p className="text-xs uppercase tracking-widest text-inkSoft mb-8 font-body">
                        {data.created_at ? new Date(data.created_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : ""}
                    </p>
                    <div className="space-y-4">
                        {data.messages.map((m, i) => (
                            <div
                                key={i}
                                data-testid={`shared-msg-${m.role}`}
                                className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}
                            >
                                <div className={`max-w-[85%] px-5 py-3 leading-relaxed font-body text-[15px] whitespace-pre-wrap ${
                                    m.role === "user"
                                        ? "bg-clay text-ink rounded-2xl rounded-tr-sm"
                                        : "bg-white text-ink rounded-2xl rounded-tl-sm border border-clayHover"
                                }`}>
                                    {m.content}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <footer className="mt-16 pb-6 text-center text-xs text-inkSoft font-body">
                created with pax · <Link to="/" className="hover:text-ink underline-offset-4 hover:underline">visit pax</Link>
            </footer>
        </div>
    );
}
